import { FormTemplateType } from '@nrwl/rx-models';
import { FeatureKey } from './feature-flags.store';

export const getVisibleFormTemplateTypes = (flags: ReadonlySet<FeatureKey>): string =>
  [
    FormTemplateType.Pdf,
    FormTemplateType.Fillable,
    ...(flags.has(FeatureKey.PERSONALIZED_PLANS) ? [FormTemplateType.PersonalizedPlan] : []),
  ].join(',');
